import { reactive } from 'vue';
import { IState } from '@/interfaces/store/state.interface';
import { StudentField } from '@studyportals/studentdomain';
import { IStudyStore } from '@/interfaces/store/study-store/study-store.store.interface';

const state: IState = reactive({
	activeStudyId: null,
	popupState: null,
	bestFitCompleteness: null,
	userLoggedIn: false,
	userData: {
		[StudentField.TUITION_BUDGET]: null,
		[StudentField.WORK_EXPERIENCE]: null,
		[StudentField.LIVING_BUDGET]: null,
		[StudentField.GPA]: null,
		[StudentField.NATIONALITY_COUNTRY_ID]: null,
		[StudentField.RESIDENCE_COUNTRY_ID]: null,
		[StudentField.CURRENCY]: 'USD',
	},
	activeMainDeterminant: null,
	activeSubDeterminant: null,
	isReady: false,
	areDependenciesLoaded: null,
	studyStores: new Map<number, IStudyStore>(),
});

export { state };
